module.exports = __webpack_public_path__ + "static/media/menu.fbfd7497.png";